import { millisecondsToHours } from 'date-fns/millisecondsToHours';
import { millisecondsToMinutes } from 'date-fns/millisecondsToMinutes';
import { millisecondsToSeconds } from 'date-fns/millisecondsToSeconds';

const MINUTES_PER_HOUR = 60;
const SECONDS_PER_MINUTE = 60;

/**
 * Renders a millisecond span as `XhYmZs`, dropping any part that is zero: `3661000` becomes
 * `"1h1m1s"`, `60000` becomes `"1m"`, and a zero span becomes `"0s"`.
 *
 * Each unit truncates towards zero, so a negative span keeps the sign on every part
 * (`-90000` is `"-1m-30s"`) instead of borrowing from the unit below.
 */
export const formatMillisecondsAsHms = (totalMilliseconds: number) => {
  const hours = millisecondsToHours(totalMilliseconds);
  const minutes = millisecondsToMinutes(totalMilliseconds) % MINUTES_PER_HOUR;
  const seconds = millisecondsToSeconds(totalMilliseconds) % SECONDS_PER_MINUTE;

  return [hours && `${hours}h`, minutes && `${minutes}m`, seconds && `${seconds}s`].filter(Boolean).join('') || '0s';
};
